import Vue from 'vue/dist/vue.min.js';
import { lory } from 'lory.js';
import EventBus from './event-bus';

// **NOTE**
// 1 index

const MarketApps = () => {

    const apps = document.querySelectorAll('.market-apps');

    const marketAppsConstructor = (id) => {

        Vue.component('market-apps-template', {
            data: function() {
                return {
                    sliderEl: null,
                    options: {
                        classNameFrame: 'market-apps__frame',
                        enableMouseEvents: true
                    },
                    lory: null,
                    length: null,
                    currentSlide: 1,
                }
            },
            methods: {
                initLory() {
                    this.lory = lory(this.sliderEl, this.options);
                },
                initListener() {
                    this.sliderEl.addEventListener('after.lory.slide', () => {
                        this.currentSlide = this.lory.returnIndex() + 1;
                    });

                    EventBus.$on('select-slide', (target) => {
                        this.currentSlide = target;
                        this.lory.slideTo(target - 1);
                    });
                },
                initTags() {
                    let tags = {
                        "type": "layer",
                        "category": "Preview Card",
                        "action": "Open",
                        "label": null,
                        "no": null
                    }
                    this.sliderEl.querySelectorAll('li').forEach((slide, i) => {
                        slide.dataset.tagMeta = JSON.stringify({
                            ...tags,
                            "label": this.$el.querySelectorAll('.market-apps__nav-item a')[i].innerText,
                            "no": (i + 1) < 10 ? `0${i + 1}` : `${i + 1}`
                        })
                    });
                }
            },
            mounted() {
                this.sliderEl = this.$el.querySelector('.market-apps__slider');
                this.length = this.$el.querySelectorAll('.market-apps__slide').length;
                this.initLory();
                this.initListener();
                this.initTags();
            }
        });

        Vue.component('market-apps-nav-item', {
            props: ['currentSlide'],
            data: function() {
                return {
                    target: null,
                    isActive: null,
                    label: null
                }            
            },
            computed: {
                taggingMeta: function() {
                    return JSON.stringify({
                        "type": "layer",
                        "category": "Preview Card",
                        "action": "Open",
                        "label": this.label,
                        "no": this.target < 10 ? `0${this.target}` : this.target.toString()
                    })
                }
              
            },
            watch: {
                currentSlide: function() {
                    this.isActive = this.target == this.currentSlide ? true : false;
                }
            },
            methods: {
                init() {
                    // set target id based on node position
                    this.target = [].indexOf.call(this.$el.parentNode.children, this.$el) + 1;   

                    this.isActive = this.target == this.currentSlide ? true : false;
                    this.label = this.$el.querySelector('a').innerText;
                },
                selectSlide() {
                    EventBus.$emit('select-slide', this.target);
                }
            },
            mounted() {
                this.init();
            }
        });

        new Vue({
            el: `.market-apps-${id}`,
        }).$mount(`.market-apps-${id}`, true);

    }

    if (apps.length > 0) {
        apps.forEach((item, index) => {
            item.classList.add(`market-apps-${index}`);
            marketAppsConstructor(index);
        })
    }

}

export default MarketApps;